import axios from "axios";
import { axiosInstance } from "../Axios";
import {
  loader,
  storeData,
  toggleErrorModal,
  setErrorMessage,
  setSuccessMessage,
  toggleBPNRModal,
  setBookingMessage,
} from "./UiReducer";
import {
  flightBalanceEtravDispatch,
  flightPaymentDebitEtravDispatch,
  flightTicketEtravDispatch,
} from "./EtravReducer";
import { walletBalanceAgentDispatch } from "./UserReducer";
const { createSlice } = require("@reduxjs/toolkit");

const HomeReducer = createSlice({
  name: "home",
  initialState: {
    success: false,
    error: null,
    loading: false,
    city: null,
    onewayflightdata: null,
    onewayflightdataEtrav: null,
    flightBook: null,
    flightBookEtrav: null,
    flightreturn: null,
    fareRule: null,
    fareRuleEtrav: null,
    fareQuote: null,
    fareQuoteEtrav: null,
    ticketGDS: null,
    releasePNR: null,
    flightLCCTicket: null,
    bookingDetail: null,
    flightCancel: null,
    cancelStatus: null,
    cancellationCharge: null,
    SSREtrav: null,
    SeatMEtrav: null,
    roundTripEtrav: null,
    orderID: null,
    addBooking: null,
    ticket: null,
    tripjack: null,
    mail: null,
    bookingHistoryTicket: null,
    ssrTBO: null,
  },
  reducers: {
    cityRequest(state, action) {
      state.loading = true;
    },
    citySuccess(state, action) {
      // state.loading = false;
      state.city = action.payload;
      state.error = null;
    },
    addSearchRequest(state, action) {
      state.loading = true;
    },

    addSearchFail(state, action) {
      // state.loading = false;
      state.error = action.payload;
    },
    cityFail(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    SSREtravRequest(state, action) {
      state.loading = true;
    },
    SSREtravSuccess(state, action) {
      state.loading = false;
      state.SSREtrav = action.payload;
      state.error = null;
    },
    SSrEtravFail(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    fareRuleRequest(state, action) {
      state.loading = true;
    },
    fareRuleSuccess(state, action) {
      state.loading = false;
      state.fareRule = action.payload;
      state.error = null;
    },
    fareRuleFail(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    flightMailRequest(state, action) {
      state.loading = true;
    },
    flightMailSuccess(state, action) {
      state.loading = false;
      state.mail = action.payload;
      state.error = null;
    },
    flightMailFail(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    fareRuleEtravRequest(state, action) {
      state.loading = true;
    },
    fareRuleEtravSuccess(state, action) {
      state.loading = false;
      state.fareRuleEtrav = action.payload;
      state.error = null;
    },
    fareRuleEtravFail(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    SeatMEtravRequest(state, action) {
      state.loading = true;
    },
    SeatMEtravSuccess(state, action) {
      state.loading = false;
      state.SeatMEtrav = action.payload;
      state.error = null;
    },
    SeatMEtravFail(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    fareQuoteRequest(state, action) {
      state.loading = true;
    },
    fareQuoteSuccess(state, action) {
      state.loading = false;
      state.fareQuote = action.payload;
      state.error = null;
    },
    fareQuoteFail(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    ssrTBORequest(state, action) {
      state.loading = true;
    },
    ssrTBOSuccess(state, action) {
      state.loading = false;
      state.ssrTBO = action.payload;
      state.error = null;
    },
    ssrTBOFail(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    fareQuoteEtravRequest(state, action) {
      state.loading = true;
    },
    fareQuoteEtravSuccess(state, action) {
      state.loading = false;
      state.fareQuoteEtrav = action.payload;
      state.error = null;
    },
    fareQuoteEtravFail(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    ticketGDSRequest(state, action) {
      state.loading = true;
    },
    ticketGDSSuccess(state, action) {
      state.loading = false;
      state.ticket = action.payload;
      state.error = null;
    },
    ticketGDSFail(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    bookingDetailRequest(state, action) {
      state.loading = true;
    },
    bookingDetailSuccess(state, action) {
      state.loading = false;
      state.bookingDetail = action.payload;
      state.error = null;
    },
    bookingDetailFail(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    searchRequest(state, action) {
      state.loading = true;
    },
    searchTripRequest(state, action) {
      state.loading = true;
    },
    searchEtravRequest(state, action) {
      state.loading = true;
    },
    searchSuccess(state, action) {
      if (state.onewayflightdataEtrav) {
        state.loading = false;
      }
      state.onewayflightdata = action.payload;
      state.error = null;
    },
    searchSuccessEtrav(state, action) {
      if (state.onewayflightdata) {
        state.loading = false;
      }
      state.onewayflightdataEtrav = action.payload;
      state.error = null;
    },
    searchSuccessTJK(state, action) {
      if (state.onewayflightdataEtrav) {
        state.loading = false;
      }
      state.tripjack = action.payload;
      state.error = null;
    },
    orderIDGenerate(state, action) {
      if (state.onewayflightdataEtrav && state.onewayflightdata) {
        state.loading = false;
      }
      state.orderID = action.payload;
      state.error = null;
    },
    searchSuccessRoundEtrav(state, action) {
      if (state.flightreturn) {
        state.loading = false;
      }
      state.roundTripEtrav = action.payload;
      state.error = null;
    },
    searchFail(state, action) {
      // state.loading = false;
      state.error = action.payload;
    },
    searchTripFail(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    searchEtravFail(state, action) {
      // state.loading = false;
      state.error = action.payload;
    },
    searchReturnRequest(state, action) {
      state.loading = true;
    },
    searchReturnEtravRequest(state, action) {
      state.loading = true;
    },
    searchReturnSuccess(state, action) {
      if (state.roundTripEtrav) {
        state.loading = false;
      }
      state.flightreturn = action.payload;
      state.error = null;
    },
    searchReturnFail(state, action) {
      // state.loading = false;
      state.error = action.payload;
    },
    searchReturnEtravFail(state, action) {
      // state.loading = false;
      state.error = action.payload;
    },
    flightBookRequest(state, action) {
      state.loading = true;
    },
    flightBookSuccess(state, action) {
      state.loading = false;
      state.flightBook = action.payload;
      state.error = null;
    },
    flightBookFail(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    flightaddBookingRequest(state, action) {
      state.loading = true;
    },
    flightaddBookingSuccess(state, action) {
      state.loading = false;
      state.addBooking = action.payload;
      state.error = null;
    },
    flightaddBookingSuccessOffline(state, action) {
      state.addBooking = action.payload;
      state.error = null;
    },
    flightaddBookingFail(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    flightBookEtravRequest(state, action) {
      state.loading = true;
    },
    flightBookEtravSuccess(state, action) {
      state.loading = false;
      state.flightBookEtrav = action.payload;
      state.error = null;
    },
    flightBookEtravFail(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    flightLCCRequest(state, action) {
      state.loading = true;
    },
    flightLCCSuccess(state, action) {
      state.loading = false;
      state.ticket = action.payload;
      state.error = null;
    },
    flightLCCFail(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    releasePNRRequest(state, action) {
      state.loading = true;
    },
    releasePNRSuccess(state, action) {
      state.loading = false;
      state.releasePNR = action.payload;
      state.error = null;
    },
    releasePNRFail(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    flightCancelRequest(state, action) {
      state.loading = true;
    },
    flightCancelSuccess(state, action) {
      state.loading = false;
      state.flightCancel = action.payload;
      state.error = null;
    },
    flightCancelFail(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    flightCancelStatusRequest(state, action) {
      state.loading = true;
    },
    flightCancelStatusSuccess(state, action) {
      state.loading = false;
      state.cancelStatus = action.payload;
      state.error = null;
    },
    flightCancelStatusFail(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    cancellationChargeRequest(state, action) {
      state.loading = true;
    },
    cancellationChargeSuccess(state, action) {
      state.loading = true;
      state.cancellationCharge = action.payload;
      state.error = null;
    },
    cancellationChargeFail(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    bookingHistoryRequest(state, action) {
      state.loading = true;
    },
    bookingHistorySuccess(state, action) {
      state.loading = false;
      state.bookingHistoryTicket = action.payload;
      state.error = null;
    },
    bookingHistoryFail(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

const { actions } = HomeReducer;
const config = {
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Client-Service": "srk-client",
    "Auth-Key": "srkapi",
    "Api-Key": "NjA4ZGFkYWQ2MjY4MA==",
  },
};
export const {
  cityRequest,
  citySuccess,
  cityFail,
  fareRuleRequest,
  fareRuleSuccess,
  fareRuleFail,
  fareRuleEtravRequest,
  fareRuleEtravSuccess,
  fareRuleEtravFail,
  fareQuoteRequest,
  fareQuoteSuccess,
  fareQuoteFail,
  fareQuoteEtravRequest,
  fareQuoteEtravSuccess,
  fareQuoteEtravFail,
  searchRequest,
  searchSuccess,
  searchSuccessEtrav,
  orderIDGenerate,
  searchSuccessRoundEtrav,
  searchFail,
  flightBookRequest,
  flightBookSuccess,
  flightBookFail,
  flightaddBookingRequest,
  flightaddBookingSuccess,
  flightaddBookingFail,
  flightBookEtravRequest,
  flightBookEtravSuccess,
  flightBookEtravFail,
  flightLCCRequest,
  flightLCCSuccess,
  flightLCCFail,
  searchReturnRequest,
  searchReturnEtravRequest,
  searchReturnSuccess,
  searchReturnFail,
  searchReturnEtravFail,
  ticketGDSRequest,
  ticketGDSSuccess,
  ticketGDSFail,
  bookingDetailRequest,
  bookingDetailSuccess,
  bookingDetailFail,
  releasePNRRequest,
  releasePNRSuccess,
  releasePNRFail,
  flightCancelRequest,
  flightCancelSuccess,
  flightCancelFail,
  flightCancelStatusRequest,
  flightCancelStatusSuccess,
  flightCancelStatusFail,
  cancellationChargeRequest,
  cancellationChargeSuccess,
  cancellationChargeFail,
  SSREtravRequest,
  SSREtravSuccess,
  SSREtravFail,
  SeatMEtravRequest,
  SeatMEtravSuccess,
  SeatMEtravFail,
  searchSuccessTJK,
  searchEtravRequest,
  searchEtravFail,
  searchTripRequest,
  searchTripFail,
  addSearchRequest,
  addSearchFail,
  flightMailFail,
  flightMailRequest,
  flightMailSuccess,
  flightaddBookingSuccessOffline,
  bookingHistoryRequest,
  bookingHistorySuccess,
  bookingHistoryFail,
  ssrTBORequest,
  ssrTBOSuccess,
  ssrTBOFail,
} = actions;

export const fetchCityDispatch = (bodyData) => async (dispatch) => {
  try {
    // dispatch(cityRequest());
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Client-Service": "srk-client",
        "Auth-Key": "srkapi",
      },
    };
    const { data } = await axiosInstance.post(
      "home/flightairport",
      bodyData,
      config
    );
    // console.log(data);
    // setResult(data);
    dispatch(citySuccess(data));
  } catch (error) {
    // dispatch(toggleErrorModal(true));
    dispatch(
      setErrorMessage(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
      )
    );
    dispatch(
      cityFail(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
      )
    );
  }
};
export const SearchFormDispatch =
  (bodyData, history, OriginO, des, origin) => async (dispatch) => {
    try {
      dispatch(searchRequest());
      dispatch(searchSuccess(null));

      const { data } = await axiosInstance.post(
        "flytbo/flightsearch",
        bodyData,
        config
      );

      // const ID = await axiosInstance.post(
      // 	'flight/addsearchflight',
      // 	bodyData,
      // 	config
      // );

      dispatch(searchSuccess(data));

      // dispatch(orderIDGenerate(ID.data));
    } catch (error) {
      // dispatch(toggleErrorModal(true));
      dispatch(
        setErrorMessage(
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        )
      );
      dispatch(
        searchFail(
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        )
      );
    }
  };
export const AddSearchFlightDispatch = (bodyData) => async (dispatch) => {
  try {
    dispatch(addSearchRequest());

    const { data } = await axiosInstance.post(
      "flight/addsearchflight",
      bodyData,
      config
    );
    dispatch(orderIDGenerate(data));
  } catch (error) {
    // dispatch(toggleErrorModal(true));
    dispatch(
      setErrorMessage(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
      )
    );
    dispatch(
      addSearchFail(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
      )
    );
  }
};
export const SearchEtravFormDispatch =
  (bodyData, history, OriginO, des, origin) => async (dispatch) => {
    try {
      dispatch(searchEtravRequest());
      dispatch(searchSuccessEtrav(null));
      // history.push({
      // 	pathname: '/oneway',
      // 	state: {
      // 		body: bodyData,
      // 		OriginO: OriginO,
      // 	},
      // });

      const etrav = await axiosInstance.post(
        "FlyEtrav/flightsearch",
        bodyData,
        config
      );

      dispatch(searchSuccessEtrav(etrav.data));
    } catch (error) {
      dispatch(toggleErrorModal(true));
      dispatch(
        setErrorMessage(
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        )
      );
      dispatch(
        searchEtravFail(
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        )
      );
    }
  };
export const SearchTripjackFormDispatch =
  (bodyData, history, OriginO, des, origin) => async (dispatch) => {
    try {
      dispatch(searchTripRequest());
      // history.push({
      // 	pathname: '/oneway',
      // 	state: {
      // 		body: bodyData,
      // 		OriginO: OriginO,
      // 	},
      // });

      const tjk = await axiosInstance.post(
        "FlyTjk/flightsearch",
        bodyData,
        config
      );

      dispatch(searchSuccessTJK(tjk.data));
    } catch (error) {
      dispatch(toggleErrorModal(true));
      dispatch(
        setErrorMessage(
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        )
      );
      dispatch(
        searchTripFail(
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        )
      );
    }
  };
export const SearchReturnFormDispatch =
  (bodyData, history, selectedOrigin, selectedDepart) => async (dispatch) => {
    try {
      dispatch(searchReturnRequest());
      history.push({
        pathname:
          selectedOrigin.country_code === "IN" &&
          selectedDepart.country_code === "IN"
            ? "/roundway"
            : "international",
        state: { returnBody: bodyData },
      });
      dispatch(loader(true));

      const { data } = await axiosInstance.post(
        "flytbo/flightsearch",
        bodyData,
        config
      );
      // const etrav = await axiosInstance.post(
      // 	'FlyEtrav/flightsearch',
      // 	bodyData,
      // 	config
      // );
      dispatch(searchReturnSuccess(data));
      // dispatch(searchSuccessRoundEtrav(etrav.data));
      // history.push({
      // 	pathname: '/roundway',
      // 	state: { returnBody: bodyData },
      // });
      // storeData('return', etrav.data);
      dispatch(loader(false));
    } catch (error) {
      dispatch(loader(false));
      dispatch(
        searchReturnFail(
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        )
      );
    }
  };
export const SearchReturnEtravFormDispatch =
  (bodyData, history,selectedOrigin, selectedDepart) => async (dispatch) => {
    try {
      dispatch(searchReturnEtravRequest());
      history.push({
        pathname:
          selectedOrigin.country_code === "IN" &&
          selectedDepart.country_code === "IN"
            ? "/roundway"
            : "international",
        state: { returnBody: bodyData },
      });
      dispatch(loader(true));

      const etrav = await axiosInstance.post(
        "FlyEtrav/flightsearch",
        bodyData,
        config
      );
      // dispatch(searchReturnSuccess(data));
      dispatch(searchSuccessRoundEtrav(etrav.data));
      // history.push({
      // 	pathname: '/roundway',
      // 	state: { RData: etrav.data, returnBody: bodyData },
      // });
      // storeData('return', etrav.data);
      dispatch(loader(false));
    } catch (error) {
      dispatch(loader(false));
      dispatch(
        searchReturnEtravFail(
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        )
      );
    }
  };
export const FlightFareRuleDispatch =
  (ResultIndex, TraceId) => async (dispatch) => {
    try {
      let bodyData = {
        TraceId: TraceId,
        ResultIndex: ResultIndex,
      };
      // dispatch(fareRuleRequest());

      const { data } = await axiosInstance.post(
        "FlyTbo/flightfarerule",
        bodyData,
        config
      );

      // console.log(data);
      dispatch(fareRuleSuccess(data));
    } catch (error) {
      dispatch(
        fareRuleFail(
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        )
      );
    }
  };

export const FlightFareRuleEtravDispatch =
  (Search_Key, Flight_Key, Fare_Id) => async (dispatch) => {
    try {
      let formData = {
        Search_Key: Search_Key,
        Flight_Key: Flight_Key,
        Fare_Id: Fare_Id,
      };
      // dispatch(fareRuleEtravRequest());

      const { data } = await axiosInstance.post(
        "FlyEtrav/flightfarerule",
        formData,
        config
      );

      // console.log(data);
      dispatch(fareRuleEtravSuccess(data));
      if (data.status === 202) {
        dispatch(toggleErrorModal(true));
        dispatch(setErrorMessage(data.message));
      }
    } catch (error) {
      dispatch(toggleErrorModal(true));
      dispatch(
        setErrorMessage(
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        )
      );
      dispatch(
        fareRuleFail(
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        )
      );
    }
  };
export const FlightFareQuoteDispatch =
  (bodyData, ssr, dispatch) => async (dispatch) => {
    try {
      dispatch(fareQuoteRequest());

      const { data } = await axiosInstance.post(
        "FlyTbo/flightfarequote",
        bodyData,
        config
      );
      // const { data } = await axiosInstance.get(
      // 	`/app/api/flight-fare-quote?TraceId=${TraceId}&ResultIndex=${rI}`
      // );
      // console.log(data);/
      dispatch(fareQuoteSuccess(data));
      if (data.status === 200) {
        dispatch(FlightSSRTBODispatch(ssr));
      }

      // dispatch(loader(false));
    } catch (error) {
      dispatch(toggleErrorModal(true));
      dispatch(
        setErrorMessage(
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        )
      );
      dispatch(
        fareQuoteFail(
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        )
      );
    }
  };
export const FlightSSRTBODispatch = (bodyData) => async (dispatch) => {
  try {
    dispatch(ssrTBORequest());

    const { data } = await axiosInstance.post(
      "FlyTbo/specialservicerequest",
      bodyData,
      config
    );
    // const { data } = await axiosInstance.get(
    // 	`/app/api/flight-fare-quote?TraceId=${TraceId}&ResultIndex=${rI}`
    // );
    // console.log(data);
    dispatch(ssrTBOSuccess(data));

    // dispatch(loader(false));
  } catch (error) {
    // dispatch(toggleErrorModal(true));
    dispatch(
      setErrorMessage(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
      )
    );
    dispatch(
      ssrTBOFail(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
      )
    );
  }
};
export const FlightFareQuoteEtravDispatch = (bodyData) => async (dispatch) => {
  try {
    dispatch(fareQuoteEtravRequest());

    const { data } = await axiosInstance.post(
      "FlyEtrav/flightreprice",
      bodyData,
      config
    );
    // console.log(data);
    dispatch(fareQuoteEtravSuccess(data));
    dispatch(flightBalanceEtravDispatch());
    if (data.status === 202) {
      dispatch(toggleErrorModal(true));
      dispatch(setErrorMessage(data.message));
    }
  } catch (error) {
    dispatch(toggleErrorModal(true));
    dispatch(
      setErrorMessage(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
      )
    );
    dispatch(
      fareQuoteEtravFail(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
      )
    );
  }
};
export const FlightBookDispatch =
  (bodyData, history, TraceId) => async (dispatch) => {
    try {
      dispatch(flightBookRequest());

      const { data } = await axiosInstance.post(
        "FlyTbo/flightbook",
        bodyData,
        config
      );

      dispatch(flightBookSuccess(data));

      // console.log(data.result.Response.Response);
      if (data.result.Response.Response) {
        let formData = {
          TraceId: TraceId,
          PNR: data.result.Response.Response.PNR,
          BookingId: data.result.Response.Response.BookingId,
        };
        dispatch(FlightTicketGDSDispatch(formData, history));
      } else {
        dispatch(toggleErrorModal(true));
        dispatch(setErrorMessage(data.message));
      }
      // if (data.data) {
      // 	dispatch(
      // 		FlightTicketDispatch(
      // 			TraceId,
      // 			data.data.Response.Response.PNR,
      // 			data.data.Response.Response.BookingId
      // 		)
      // 	);
      // 	history.push('/ticket');
      // 	dispatch(
      // 		FlightBookingDetailDispatch(
      // 			data.data.Response.Response.PNR,
      // 			data.data.Response.Response.BookingId
      // 		)
      // 	);
      // }
      // alert(
      // 	data.Response
      // 		? data.Response.Error.ErrorMessage
      // 		: 'Ticket Generate Successfully'
      // );

      // console.log('Ticket');
      // }
    } catch (error) {
      // console.log(error);
      dispatch(toggleErrorModal(true));
      dispatch(loader(false));
      dispatch(
        setErrorMessage(
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        )
      );
      dispatch(
        flightBookFail(
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        )
      );
    }
  };

export const FlightAddBookingDispatch =
  (bodyData, payment) => async (dispatch) => {
    try {
      dispatch(flightaddBookingRequest());

      const { data } = await axiosInstance.post(
        "flight/addbookingflight",
        bodyData,
        config
      );
      if (payment === "offline") {
        dispatch(flightaddBookingSuccessOffline(data));
      } else {
        dispatch(flightaddBookingSuccess(data));
      }
    } catch (error) {
      dispatch(toggleErrorModal(true));
      dispatch(loader(false));
      dispatch(
        flightaddBookingFail(
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        )
      );
    }
  };
export const FlightSSREtravDispatch = (bodyData) => async (dispatch) => {
  try {
    dispatch(SSREtravRequest());

    const { data } = await axiosInstance.post(
      "FlyEtrav/specialservicerequest",
      bodyData,
      config
    );
    // console.log(data);
    dispatch(SSREtravSuccess(data));
  } catch (error) {
    dispatch(
      SSREtravFail(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
      )
    );
  }
};
export const FlightSeatMapEtravDispatch = (bodyData) => async (dispatch) => {
  try {
    dispatch(SeatMEtravRequest());

    const { data } = await axiosInstance.post(
      "FlyEtrav/flightseatmap",
      bodyData,
      config
    );
    // console.log(data);
    dispatch(SeatMEtravSuccess(data));
  } catch (error) {
    dispatch(
      SeatMEtravFail(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
      )
    );
  }
};
export const FlightBookEtravDispatch =
  (bodyData, history, payment, states, agentlogin) => async (dispatch) => {
    try {
      dispatch(flightBookEtravRequest());

      const { data } = await axiosInstance.post(
        "FlyEtrav/flightbooking",
        bodyData,
        config
      );

      dispatch(flightBookEtravSuccess(data));
      if (data.status === 200 && data.result.Booking_RefNo) {
        let payment = {
          ProductId: "1",
          RefNo: data.result.Booking_RefNo,
          TransactionType: "0",
        };
        dispatch(
          flightPaymentDebitEtravDispatch(
            payment,
            data.result.Booking_RefNo,
            history,
            states,
            agentlogin
          )
        );
        // dispatch(flightTicketEtravDispatch(ticketData, history));
        // }
      } else {
        dispatch(toggleBPNRModal(true));
        dispatch(
          setBookingMessage(
            "Your Tansaction is duplicate. Your Previous TransactionId :FBB66WTS"
          )
        );
        // dispatch(toggleErrorModal(true));
        // dispatch(
        // 	setErrorMessage(data.result.Response_Header.Error_InnerException)
        // );
      }
    } catch (error) {
      dispatch(
        flightBookEtravFail(
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        )
      );
    }
  };
export const FlightTicketLCCDispatch =
  (bodyData, history, mail, agentlogin) => async (dispatch) => {
    try {
      dispatch(flightLCCRequest());

      const { data } = await axiosInstance.post(
        "FlyTbo/flightticketlcc",
        bodyData,
        config
      );

      dispatch(flightLCCSuccess(data));
      dispatch(
        walletBalanceAgentDispatch(
          agentlogin && agentlogin.result.result.email,
          agentlogin && agentlogin.result.result.id
        )
      );
      // dispatch(loader(false));
      // console.log(data.data);
      if (data.status === 200) {
        history.push({
          pathname: "/ticket",
          state: {
            mailBody: mail,
          },
        });
        let formMail = {
          orderId: mail.orderID,
          userEmail: mail.formData.email,
        };
        dispatch(FlightMailTicketDispatch(formMail));
      } else {
        // dispatch(toggleErrorModal(true));
        dispatch(toggleBPNRModal(true));
        dispatch(setBookingMessage(data.message));
        // dispatch(setErrorMessage(data.message));
      }

      // console.log('Ticket');
      // }
    } catch (error) {
      dispatch(loader(false));
      dispatch(
        flightLCCFail(
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        )
      );
    }
  };

export const FlightMailTicketDispatch = (bodyData) => async (dispatch) => {
  try {
    dispatch(flightMailRequest());

    const { data } = await axiosInstance.post(
      "flight/mailticket",
      bodyData,
      config
    );

    dispatch(flightMailSuccess(data));
    // dispatch(loader(false));
    // console.log(data.data);
    // if (data.status === 200) {
    // 	history.push('/ticket');
    // 	// alert('This is Lcc Ticket');
    // } else {
    // 	dispatch(toggleErrorModal(true));
    // 	dispatch(setErrorMessage(data.message));
    // }

    // console.log('Ticket');
    // }
  } catch (error) {
    dispatch(loader(false));
    dispatch(
      flightMailFail(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
      )
    );
  }
};
export const FlightTicketGDSDispatch =
  (bodyData, history) => async (dispatch) => {
    try {
      dispatch(ticketGDSRequest());

      const { data } = await axiosInstance.post(
        "FlyTbo/flightticketgds",
        bodyData,
        config
      );
      // console.log(data);
      dispatch(ticketGDSSuccess(data));
      if (data.status === 200) {
        history.push("/ticket");
        // alert('This is Non-Lcc Ticket');
      } else {
        dispatch(toggleErrorModal(true));
        dispatch(setErrorMessage(data.message));
      }
    } catch (error) {
      dispatch(toggleErrorModal(true));
      dispatch(
        ticketGDSFail(
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        )
      );
    }
  };
export const FlightBookingDetailDispatch =
  (PNR, bookingId, history) => async (dispatch) => {
    try {
      dispatch(loader(true));
      dispatch(bookingDetailRequest());
      let formData = {
        PNR: PNR,
        BookingId: bookingId,
      };

      const { data } = await axiosInstance.post(
        "FlyTbo/flightbookingdetails",
        formData,
        config
      );
      // console.log(data);
      dispatch(bookingDetailSuccess(data));
      if (data) {
        history.push("/ticketdisplay");
      }
      dispatch(loader(false));
    } catch (error) {
      dispatch(loader(false));
      dispatch(
        bookingDetailFail(
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        )
      );
    }
  };

export const FlightReleasePNRDispatch =
  (bodyData, history) => async (dispatch) => {
    try {
      dispatch(releasePNRRequest());

      const { data } = await axiosInstance.post(
        "FlyTbo/flightreleasepnr",
        bodyData,
        config
      );
      // console.log(data);
      dispatch(releasePNRSuccess(data));
      dispatch(loader(false));
    } catch (error) {
      dispatch(loader(false));
      dispatch(
        releasePNRFail(
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        )
      );
    }
  };

export const FlightCancelDispatch = (bodyData, history) => async (dispatch) => {
  try {
    dispatch(flightCancelRequest());

    const { data } = await axiosInstance.post(
      "FlyTbo/flighcancel",
      bodyData,
      config
    );
    // console.log(data);
    dispatch(flightCancelSuccess(data));
  } catch (error) {
    dispatch(
      flightCancelFail(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
      )
    );
  }
};

export const FlightCancelStatusDispatch =
  (bodyData, history) => async (dispatch) => {
    try {
      dispatch(flightCancelStatusRequest());

      const { data } = await axiosInstance.post(
        "FlyTbo/flighcancelstatus",
        bodyData,
        config
      );
      // console.log(data);
      dispatch(flightCancelStatusSuccess(data));
    } catch (error) {
      dispatch(
        flightCancelStatusFail(
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        )
      );
    }
  };

export const FlightCancellationChargeDispatch =
  (bodyData, history) => async (dispatch) => {
    try {
      dispatch(cancellationChargeRequest());

      const { data } = await axiosInstance.post(
        "FlyTbo/flighcancellationcharge",
        bodyData,
        config
      );
      // console.log(data);
      dispatch(cancellationChargeSuccess(data));
    } catch (error) {
      dispatch(
        cancellationChargeFail(
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        )
      );
    }
  };

export const FlightAgentBookingHistoryDispatch =
  (PNR, bookingId, supplier, history) => async (dispatch) => {
    try {
      dispatch(loader(true));
      dispatch(bookingHistoryRequest());
      let formData = {
        PNR: PNR,
        BookingId: bookingId,
      };
      let formDataETR = {
        Airline_PNR: PNR,
        Booking_RefNo: bookingId,
      };

      const { data } = await axiosInstance.post(
        supplier === "ETR"
          ? "FlyEtrav/flightreprint"
          : "FlyTbo/flightbookingdetails",
        supplier === "ETR" ? formDataETR : formData,
        config
      );
      // console.log(data);
      dispatch(bookingHistorySuccess(data));
      if (data) {
        history.push("/ticketdisplay");
      }
      dispatch(loader(false));
    } catch (error) {
      dispatch(loader(false));
      dispatch(
        bookingHistoryFail(
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        )
      );
    }
  };

export default HomeReducer;
